/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: *management-units*.main.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog>Management Units Component
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from "react";
import $ from "jquery";
import {default as UserDetail} from "./users/Detail";
import {default as UserTable} from "./users/Table";
//import {default as OrganizationDetail} from "./organizations/Detail";
import {default as OrganizationTable} from "./organizations/Table";
import OrganizationDetail from "./common/OrganizitaionDetail";
import AddUserModal from "./users/modals/addUserModal";
import EditUserModal from "./users/modals/editUserModal";
import RowDeleteModal from "../../modal/rowDelete";
import AddOrganization from "./users/modals/addOrganizitaion";
import ColumnList from "../../../common/componet-jsons/column-list-catalog.json";
import * as CommonFunctions from "./common/commonFunctions";
import {sleep} from "../../../common/common";
import OrganizationEditModal from "./organizations/Edit";

class ManagementUnits extends React.Component {
    constructor(props) {
        super(props);
    }

    SetUserTreeOpen() {
        this.SetATreeOpen("gebruikersbeheer")
    }

    SetOrganizationTreeOpen() {
        this.SetATreeOpen("organisatie")
    }

    SetATreeOpen(tree, wait = 150) {
        this.SetAllClose();
        sleep(wait).then(() => {
            $("[data-id=" + tree + "]").addClass('open act')
        })
    }

    SetAllClose() {
        $("[data-id=organisatie]").removeClass('open act')
        $("[data-id=gebruikersbeheer]").removeClass('open act')
    }

    HandleOpenedTree(){
        if(!this.props.location.state || this.props.location.state?.id === "gebruikersbeheer"){
            this.SetUserTreeOpen()
        }
        else if (this.props.location.state?.id === "organisatie"){
            this.SetOrganizationTreeOpen()
        }
    }

    async componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        this.HandleOpenedTree();
    }

    componentDidMount() {
        this.HandleOpenedTree();

        ColumnList.forEach(function (item) {
            if (item.name === "catalog>users") {
                window.$catalog_users_columnList = item["column-list"];
            }
        });

        /*** EKRANIN HERHANGİ BİRYERİNE TIKLANINCA POPUP KALDIRMAK İÇİN KULLANILAN FONKSİYON ***/
        $(document)
            .unbind("mouseup")
            .mouseup(function (e) {
                const popup = $("#myPopup");
                if (
                    !$("div.popup").is(e.target) &&
                    !popup.is(e.target) &&
                    popup.has(e.target).length === 0
                ) {
                    popup.html("");

                    popup.removeClass("show");
                }
            });

        $(document).on("click", ".catalog-action", function () {
            const actionId = $(this).attr("id");
            let modalId = window.$catalog_users_actions.filter(
                (act) => act["id"] === actionId
            )[0]["modal"];
            $("#" + modalId).modal("show");
        });
    }

    render() {
        return (
            <div className="border p-3 br5 full-width" id="border-mid">
                {!this.props.location.state || this.props.location.state?.id === "gebruikersbeheer" ?
                    <div>
                        <UserTable {...this.props} />
                        <UserDetail/>
                        <OrganizationDetail/>
                        <AddUserModal/>
                        <EditUserModal/>
                        <AddOrganization/>
                        <RowDeleteModal
                            id="user-delete-modal"
                            handleDelete={CommonFunctions.rowsHandleDelete}
                        />
                    </div> :
                    this.props.location.state?.id === "organisatie" ?
                        <div>
                            <OrganizationTable {...this.props}/>
                            <OrganizationDetail/>
                            <OrganizationEditModal/>
                        </div> :
                        <div>
                            Something went wrong!
                        </div>
                }
            </div>
        );
    }
}

export default ManagementUnits;
